// import header1 from '@/components/inc/header.vue' // ComponentA 
import zpagenav from '@/components/inc/pageblock.vue' // ComponentA 
import chainMap from '@/components/inc/chainmap.vue' // ComponentA 
import chain from '@/components/inc/chain.vue' // ComponentA 
import loading from '@/components/inc/loading.vue' // ComponentA 
import tipspop from '@/components/inc/tipspop.vue' // ComponentA 
import listMenu from '@/components/inc/listmenu.vue' // ComponentA 
import percentloop from '@/components/inc/percentloop.vue' // ComponentA  
import index from '@/components/index.vue' // ComponentB
import resize from '@/utils/resize.vue' // ComponentB
import countTo from 'vue-count-to' // 数字滚动 
import leftnav from '@/components/inc/leftnav.vue' // 左侧菜单栏  
// import bottomnav from '@/components/inc/bottomnav.vue' // 大屏底部菜单栏gov_header
import govheader from '@/components/inc/govheader.vue' // 政府端底部菜单 
import ClueNav from '@/components/recommend/clue-nav.vue';
import dynamicNavTZ from '@/components/touzi/dynamic-nav.vue';
import dynamicNav from '@/components/dynamic/dynamicNav.vue';
import cluetips from '@/components/recommend/cluetips.vue';
import daswiperNav from '@/components/inc/swiperNav.vue';
import videoTeaching from '@/components/inc/VideoTeaching.vue';
import rightNav from '@/components/inc/rightNav.vue';
import operatdemo from '@/components/inc/operatDemo.vue';
import finacingTime from '@/components/inc/finacingTime.vue'; //融资时间的统一展示
import notionScreen from '@/components/inc/notionScreen.vue'; //企业列表概念notion筛选统一展示
import cityScreen from '@/components/inc/cityScreen.vue'; //省市区筛选统一展示
import watermark from '@/components/inc/watermark.vue' //水印
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue" //二维码提示框

//*表格统一*/
import domesticTable from '@/components/inc/table/domesticTable.vue'; //全部内资企业表格
import innovateTable from '@/components/inc/table/innovateTable.vue'; //创新企业表格

import riskInformation from '@/components/enterpriseInc/riskInformation.vue'; //企业详情页模块命名-风险预警
import equityPledge from '@/components/enterpriseInc/equityPledge.vue'; //企业详情页模块命名-股权质押
import solvency from '@/components/enterpriseInc/solvency.vue'; //企业详情页模块命名-偿债能力
import vedioTips from '@/components/inc/vedio-tips.vue' //水印





export default (Vue) => {
	Vue.component('Resize', resize)
	// Vue.component('headerbar', header1)   
	Vue.component('zpagenav', zpagenav)
	Vue.component('chainMap', chainMap)
	Vue.component('chain', chain)
	Vue.component('loading', loading)
	Vue.component('tipspop', tipspop)
	Vue.component('listMenu', listMenu)
	Vue.component('percentLoop', percentloop)
	Vue.component('countTo', countTo)
	Vue.component('leftnav', leftnav)
	Vue.component('govheader', govheader)
	Vue.component('ClueNav', ClueNav);
	Vue.component('dynamicNavTZ', dynamicNavTZ);
	Vue.component('cluetips', cluetips);
	Vue.component('daswiperNav', daswiperNav);
	Vue.component('riskInfo', riskInformation);
	Vue.component('equityPledge', equityPledge);
	Vue.component('solvency', solvency);
	Vue.component('videoTeaching', videoTeaching);
	Vue.component('rightNav', rightNav);
	Vue.component('dynamicNav', dynamicNav);
	Vue.component('operatDemo', operatdemo);
	Vue.component('finacingTime', finacingTime);
	Vue.component('notionScreen', notionScreen);
	Vue.component('cityScreen', cityScreen);
	Vue.component('domesticTable', domesticTable);
	Vue.component('innovateTable', innovateTable);
	Vue.component('watermark', watermark);
	Vue.component('freeUserTips', freeUserTips);
	Vue.component('vedioTips', vedioTips);
	
	

}